import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Cards from '../../components/layouts/Cards';
import { Link } from "gatsby";
export const _frontmatter = {
  "links": ["/sequence-diagram", "/gantt-diagram"]
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Cards;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Sequence diagrams`}</h2>
    <img src="https://graph-up.herokuapp.com/Y3Ms4Wu4" />
    <p>{`Explain how services interact, ideal for complex API call sequences.`}</p>
    <h2>{`Gantt diagrams`}</h2>
    <img src="https://graph-up.herokuapp.com/weIm0VhT" />
    <p>{`Show how long each tasks takes, and which are executed in parallel. Ideal for tracing.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      